<template>
  <div id="index" style="max-width:700px;">
    <v-layout row wrap style="width:100%;">
      <transition name="a1">
        <div v-show="showA1" style="width:100px;height:500px;background:#00ff00;"></div>
      </transition>
      <transition name="a2">
       <div v-show="showA2" style="width:100px;height:500px;background:#00ffff;"></div>
      </transition>
    </v-layout>
  </div>
</template>

<script>
// import { db } from '../main'
export default {
  name: 'View',
  data () {
    return {
      show: false,
      showA1: false,
      showA2: false
    }
  },
  computed: {
    isLogin () {
      return this.$store.state.view.isLogin
    }
  },
  head: {
    title: function () {
      return {
        inner: '平成年表',
        separator: '|',
        complement: 'ありがとう、平成'
      }
    },
    meta: function () {
      return [
        {name: 'twitter:title', content: 'ありがとう、平成'},
        {property: 'og:title', content: 'ありがとう、平成'},
        {name: 'twitter:description', content: '平成年表は平成の想い出を気軽に投稿しシェアできるサイトです。平成の想い出を年表にして投稿してみよう。'},
        {name: 'description', content: '平成年表は平成の想い出を気軽に投稿しシェアできるサイトです。平成の想い出を年表にして投稿してみよう。'},
        {name: 'twitter:image', content: 'https://www.katsulabo.com/heisei/image/heisei-nenpyo.png'},
        {property: 'og:image', content: 'https://www.katsulabo.com/heisei/image/heisei-nenpyo.png'}
      ]
    }
  },
  filters: {
    textTrim: function (value) {
      let max = 30
      if (value.length >= 30) return value.substring(0, max - 1) + '...'
      return value
    },
    displayDate (value) {
      let date = new Date()
      let now = date.getTime()
      date.setTime(value.seconds * 1000)
      let diff = (now - value.seconds * 1000) / (60 * 1000) // 分
      if (diff < 60) {
        return `${Math.floor(diff)}分前`
      } else if (diff < 24 * 60) {
        return `${Math.floor(diff / 60)}時間前`
      } else {
        return `${date.getMonth() + 1}月${date.getDate()}日`
      }
    }
  },
  created () {
    this.refresh()
  },
  mounted () {
    setTimeout(() => {
      this.showA2 = false
    }, 400)
    setTimeout(() => {
      this.showA1 = true
    }, 250)
    setTimeout(() => {
      this.showA1 = false
    }, 500)
    this.showA2 = true
  },
  methods: {
    refresh () {
    }
  },
  components: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import url("../assets/css/common.css");
.a1-enter {
  opacity: 0;
}
.a1-enter-to {
  opacity: 1;
}
.a1-enter-active {
  transition: opacity 270ms ease;
}
.a1-leave-to {
  opacity: 0;
  transform: translateY(300px);
}
.a1-leave-active {
  transition: opacity 270ms ease , transform 270ms ease;
}

.a2-enter {
  opacity: 0;
  transform: translateX(calc(50% + 100px));
}
.a2-enter-to {
  opacity: 1;
  transform: translateX(50%);
}
.a2-enter-active {
  transition: opacity 270ms ease , transform 270ms ease;
}
.a2-leave-to {
  opacity: 0;
}
.a2-leave-active {
  transition: opacity 270ms ease;
}

.q1-enter {
  /*開始の状態を指定する*/
  opacity: 0;
  transform: translateX(-200px);
}
.f1-enter-to {
  /*終了の状態を指定する*/
  opacity: 1;
  transform: translateX(0px);
}
.f1-enter-active {
   /*動作（イージングや時間）を指定する*/
  transition: opacity 500ms ease , transform 500ms ease;
}
.f1-leave-to {
  /*終了の状態を指定する*/
  opacity: 0;
  transform: translateY(-600px);
}
.f1-leave-active {
   /*動作（イージングや時間）を指定する*/
  transition: opacity 1500ms ease , transform 1500ms ease;
}
</style>



// WEBPACK FOOTER //
// src/components/TopAnimation.vue